// Mock data pour le prototype visuel wyvio
// Aucune logique métier — uniquement pour valider l'expérience utilisateur.

export const STEP_STATUS = {
  DONE: "termine",
  IN_PROGRESS: "en_cours",
  UPCOMING: "a_venir",
  BLOCKED: "bloque",
};

// Étapes canoniques du parcours véhicule.
// Chaque étape a une couleur de statut très visible sur la carte dossier.
export const STEPS_TEMPLATE = [
  { key: "reservation",  label: "Réservation",          color: "gray"   },
  { key: "acompte",      label: "Acompte reçu",         color: "gray"   },
  { key: "admin",        label: "Dossier administratif", color: "gray"   },
  { key: "check",        label: "Check contrôle",       color: "orange" },
  { key: "ct",           label: "Contrôle technique",   color: "yellow" },
  { key: "esthetique",   label: "Préparation esthétique", color: "yellow" },
  { key: "pret",         label: "Véhicule prêt",        color: "green"  },
  { key: "livraison",    label: "Livraison",            color: "blue"   },
  { key: "cpi",          label: "CPI disponible",       color: "green"  },
];

const buildSteps = (currentIndex, blockedIndex = -1) =>
  STEPS_TEMPLATE.map((s, i) => {
    let status = STEP_STATUS.UPCOMING;
    if (i < currentIndex) status = STEP_STATUS.DONE;
    else if (i === currentIndex) status = STEP_STATUS.IN_PROGRESS;
    if (i === blockedIndex) status = STEP_STATUS.BLOCKED;
    return { ...s, status };
  });

// Résout le statut "actuel" d'un dossier à partir de ses étapes
const resolveCurrent = (steps) => {
  const blocked = steps.find((s) => s.status === STEP_STATUS.BLOCKED);
  if (blocked) return { label: "Bloqué", color: "red", stepLabel: blocked.label };
  const inProgress = steps.find((s) => s.status === STEP_STATUS.IN_PROGRESS);
  if (inProgress) return { label: inProgress.label, color: inProgress.color, stepLabel: inProgress.label };
  // Tout terminé
  return { label: "Prêt à livrer", color: "green", stepLabel: "CPI disponible" };
};

const RAW_VEHICLES = [
  {
    id: "bc-2026-0147",
    name: "Audi RS3",
    image:
      "https://images.unsplash.com/photo-1616422285623-13ff0162193c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxBdWRpJTIwUlN8ZW58MHx8fHwxNzgzMDA4MjIzfDA&ixlib=rb-4.1.0&q=85",
    orderNumber: "BC-2026-0147",
    progress: 72,
    availabilityDate: "10 juillet 2026",
    reservationDate: "12 février 2026",
    client: "Stéphane Marchand",
    commercial: "Julien Petit",
    lastUpdate: "il y a 2 h",
    steps: buildSteps(5),
  },
  {
    id: "bc-2026-0203",
    name: "Porsche 911 Carrera",
    image:
      "https://images.unsplash.com/photo-1634673970798-a15ae56f6c65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxQb3JzY2hlJTIwOTExfGVufDB8fHx8MTc4MzAwODIyMnww&ixlib=rb-4.1.0&q=85",
    orderNumber: "BC-2026-0203",
    progress: 88,
    availabilityDate: "24 juin 2026",
    reservationDate: "3 janvier 2026",
    client: "Marie Dupont",
    commercial: "Amélie Girard",
    lastUpdate: "il y a 40 min",
    steps: buildSteps(6),
  },
  {
    id: "bc-2026-0189",
    name: "BMW M4 Competition",
    image:
      "https://images.unsplash.com/photo-1683638287438-7710b87ffb41?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxCTVclMjBNNHxlbnwwfHx8fDE3ODMwMDgyMjJ8MA&ixlib=rb-4.1.0&q=85",
    orderNumber: "BC-2026-0189",
    progress: 45,
    availabilityDate: "18 août 2026",
    reservationDate: "22 janvier 2026",
    client: "Antoine Rey",
    commercial: "Julien Petit",
    lastUpdate: "il y a 1 j",
    steps: buildSteps(3),
  },
  {
    id: "bc-2026-0164",
    name: "Mercedes-AMG GT",
    image:
      "https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxNZXJjZWRlcyUyMEFNR3xlbnwwfHx8fDE3ODMwMDgyMjN8MA&ixlib=rb-4.1.0&q=85",
    orderNumber: "BC-2026-0164",
    progress: 22,
    availabilityDate: "12 septembre 2026",
    reservationDate: "5 février 2026",
    client: "Léa Bernard",
    commercial: "Amélie Girard",
    lastUpdate: "il y a 3 j",
    steps: buildSteps(1),
  },
  {
    id: "bc-2026-0221",
    name: "Range Rover Sport",
    image:
      "https://images.unsplash.com/photo-1638686302275-0e87df720aca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxSYW5nZSUyMFJvdmVyfGVufDB8fHx8MTc4MzAwODIyMnww&ixlib=rb-4.1.0&q=85",
    orderNumber: "BC-2026-0221",
    progress: 60,
    availabilityDate: "2 juillet 2026",
    reservationDate: "18 janvier 2026",
    client: "Nicolas Perrin",
    commercial: "Julien Petit",
    lastUpdate: "il y a 5 h",
    steps: buildSteps(4),
  },
  {
    id: "bc-2026-0175",
    name: "Aston Martin Vantage",
    image:
      "https://images.unsplash.com/photo-1573593612929-45d67798b534?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxBc3RvbiUyME1hcnRpbnxlbnwwfHx8fDE3ODMwMDgyMjJ8MA&ixlib=rb-4.1.0&q=85",
    orderNumber: "BC-2026-0175",
    progress: 35,
    availabilityDate: "26 août 2026",
    reservationDate: "14 janvier 2026",
    client: "Camille Fabre",
    commercial: "Amélie Girard",
    lastUpdate: "il y a 20 min",
    steps: buildSteps(2, 3),
  },
  {
    id: "bc-2026-0132",
    name: "Audi RS6 Avant",
    image:
      "https://images.unsplash.com/photo-1589536672709-a5d34b12466d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxBdWRpJTIwUlN8ZW58MHx8fHwxNzgzMDA4MjIzfDA&ixlib=rb-4.1.0&q=85",
    orderNumber: "BC-2026-0132",
    progress: 100,
    availabilityDate: "17 juin 2026",
    reservationDate: "9 décembre 2025",
    client: "Thomas Lefèvre",
    commercial: "Julien Petit",
    lastUpdate: "il y a 1 h",
    steps: buildSteps(9),
  },
  {
    id: "bc-2026-0244",
    name: "Porsche 911 Turbo S",
    image:
      "https://images.unsplash.com/photo-1740940339304-651f421985b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxQb3JzY2hlJTIwOTExfGVufDB8fHx8MTc4MzAwODIyMnww&ixlib=rb-4.1.0&q=85",
    orderNumber: "BC-2026-0244",
    progress: 12,
    availabilityDate: "3 octobre 2026",
    reservationDate: "1 février 2026",
    client: "Emma Roussel",
    commercial: "Amélie Girard",
    lastUpdate: "il y a 6 h",
    steps: buildSteps(0),
  },
  {
    id: "bc-2026-0256",
    name: "BMW iX M60",
    image:
      "https://images.unsplash.com/photo-1683638287438-7710b87ffb41?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxCTVclMjBNNHxlbnwwfHx8fDE3ODMwMDgyMjJ8MA&ixlib=rb-4.1.0&q=85",
    orderNumber: "BC-2026-0256",
    progress: 55,
    availabilityDate: "22 juillet 2026",
    reservationDate: "9 février 2026",
    client: "Julien Blanc",
    commercial: "Julien Petit",
    lastUpdate: "il y a 3 h",
    steps: buildSteps(4),
  },
  {
    id: "bc-2026-0261",
    name: "Mercedes-AMG C63 S",
    image:
      "https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxNZXJjZWRlcyUyMEFNR3xlbnwwfHx8fDE3ODMwMDgyMjN8MA&ixlib=rb-4.1.0&q=85",
    orderNumber: "BC-2026-0261",
    progress: 80,
    availabilityDate: "5 juillet 2026",
    reservationDate: "20 janvier 2026",
    client: "Sarah Moreau",
    commercial: "Amélie Girard",
    lastUpdate: "il y a 25 min",
    steps: buildSteps(6),
  },
  {
    id: "bc-2026-0270",
    name: "Porsche Cayenne GTS",
    image:
      "https://images.unsplash.com/photo-1740940339304-651f421985b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxQb3JzY2hlJTIwOTExfGVufDB8fHx8MTc4MzAwODIyMnww&ixlib=rb-4.1.0&q=85",
    orderNumber: "BC-2026-0270",
    progress: 92,
    availabilityDate: "28 juin 2026",
    reservationDate: "15 décembre 2025",
    client: "Lucas Girard",
    commercial: "Julien Petit",
    lastUpdate: "il y a 15 min",
    steps: buildSteps(7),
  },
];

export const VEHICLES = RAW_VEHICLES.map((v) => {
  const current = resolveCurrent(v.steps);
  const isFinished = v.steps.every((s) => s.status === STEP_STATUS.DONE);
  return { ...v, currentStatus: current, isFinished };
});

// KPIs actionnables — centre de pilotage
export const KPIS = [
  {
    key: "livraisons",
    icon: "truck",
    label: "Livraisons",
    sublabel: "aujourd'hui",
    value: 3,
    accent: true,
    tone: "primary", // vert fluo
  },
  {
    key: "messages",
    icon: "inbox",
    label: "Nouveaux",
    sublabel: "messages",
    value: 12,
    tone: "info", // bleu discret
  },
  {
    key: "bloques",
    icon: "alert",
    label: "Dossiers",
    sublabel: "bloqués",
    value: 2,
    tone: "danger", // rouge doux
  },
  {
    key: "cpi",
    icon: "file",
    label: "CPI",
    sublabel: "à remettre",
    value: 5,
    tone: "warning", // ambre
  },
];

export const getVehicleById = (id) =>
  VEHICLES.find((v) => v.id === id) || VEHICLES[0];

// Table de correspondance couleurs statut → tokens Tailwind
export const STATUS_COLORS = {
  green:  { dot: "#22C55E", bg: "bg-[#DCFCE7]", text: "text-[#166534]", ring: "ring-[#22C55E]/25" },
  yellow: { dot: "#EAB308", bg: "bg-[#FEF9C3]", text: "text-[#854D0E]", ring: "ring-[#EAB308]/25" },
  orange: { dot: "#F97316", bg: "bg-[#FFEDD5]", text: "text-[#9A3412]", ring: "ring-[#F97316]/25" },
  blue:   { dot: "#3B82F6", bg: "bg-[#DBEAFE]", text: "text-[#1E40AF]", ring: "ring-[#3B82F6]/25" },
  gray:   { dot: "#9CA3AF", bg: "bg-[#F3F4F6]", text: "text-[#374151]", ring: "ring-[#9CA3AF]/25" },
  red:    { dot: "#EF4444", bg: "bg-[#FEE2E2]", text: "text-[#991B1B]", ring: "ring-[#EF4444]/25" },
};
